import React from "react";
import GuideLayout from "../../components/layout/GuideLayout";
import Section from "../../components/layout/Section";
import Subheader from "../../components/layout/Subheader";
import {
  Typography,
  Link,
  Box,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CodeHighlight from "../../components/layout/CodeHighlight";

const October2026 = () => {
  const theme = useTheme();

  return (
    <GuideLayout sections={[]}>
      <Section id="intro" title="Now Fansite Certified!">
        <Typography
          variant="caption"
          color="secondary"
          sx={{ mt: -1, mb: 2, display: "block" }}
        >
          October 2026 Update
        </Typography>
        <Typography paragraph>
          We are happy to announce that we are now officially a <b>certified fan site</b> by TNT! We got the news a while ago and you might have seen our post on the Discord server, but here's our official update because we also have a new feature added :)
        </Typography>
        <Box sx={{ textAlign: "center" }}>
          <img src={require('../../assets/fansite.png')} alt="certified fansite list" style={{ maxWidth: "350px", borderRadius: 8, marginTop: 16, height: "50%" }} />
        </Box>

        <Subheader title="Can we link on boards?" />
        <Typography paragraph>
          There is not much recent information on limitations for fansites at the moment. As far as we know from editorials and digging around, our fansite certification means that anyone can reference Stylisher on site now. However, since we do not have recommended status and only certified, direct links to our site would not be whitelisted. Something like "you can check out the Stylisher fansite for guides" or "I looked up this item on Stylisher and last report was at 2 caps" is likely fine, but a direct link to view an item's trade reports might not. If you want to direct anyone towards us, we are listed and link on the community hub tab so you can always post <CodeHighlight text="http://neopets.com/community/index.phtml" /> on the boards or neomails for a direct reference. We encourage everyone to stay on the safe side when posting on neoboards!
        </Typography>

        <Subheader title={"Anonymous Reporter Labels"} />
        <Typography paragraph>
          We've added anonymous reporter labels to trade reports on this website! When you search an item, you'll see a "Reported by CHARACTER" label, which indicates when multiple trade reports were submitted by the same person. This feature is intended to give more context to traders about the data they see while still allowing all reports to be anonymous.
        </Typography>

        <Typography paragraph>
          All labels are named after Neopian characters and are randomized per search so usernames are not linked nor displayed at all. We've also added more information about this in our <Link href="/articles/how-a-value-guide-works#anonymous-reporter-labels" sx={{ color: theme.palette.primary.main }}>How a Value Guide Works</Link> article about this. As always, if you have any feedback regarding this feature or anything else about Stylisher, let us know in our Discord server!
        </Typography>
        <Box sx={{ textAlign: "center" }}>
          <img src={require('../../assets/anon_reporter_label_example.png')} alt="example of anonymous reporter labels toggled on" style={{  maxWidth: "80%", borderRadius: 8, marginTop: 16 }} />
        </Box>

      </Section>

    </GuideLayout>
  );
};

export default October2026;
